module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/employer/templates/PayrollItemSelectionButton.html -->\n<div class="row">\n    <div class="btn-item-left btn-item-icon">\n        ';
 if (model.get('category') === 1) {
__p+='\n            <i class="fa fa-rocket text-success"></i>\n        ';
}
__p+='\n        ';
 if (model.get('category') === 4) {
__p+='\n            <i class="fa fa-gift text-success"></i>\n        ';
}
__p+='\n        ';
 if (model.get('category') === 0) {
__p+='\n            <i class="fa fa-money text-info"></i>\n        ';
}
__p+='\n        ';
 if (model.get('category') === 3) {
__p+='\n            <i class="fa fa-minus-circle text-warning"></i>\n        ';
}
__p+='\n        ';
 if (model.get('category') === 2) {
__p+='\n            <i class="fa fa-briefcase text-navy"></i>\n        ';
}
__p+='\n    </div>\n    <div class="btn-item-label">\n        <h5>\n            '+
((__t=( model.get('name') ))==null?'':_.escape(__t))+
'\n            <small>\n                ';
 if (additionalInfo) { 
__p+='\n                    (\n                        ';
 last = _.last(_.keys(additionalInfo)); 
__p+='\n                        ';
 _.each(_.keys(additionalInfo), function(attr, i) { 
__p+='\n                            '+
((__t=( additionalInfo[attr] + (
                                attr !== last ? ', ' : ''
                            ) ))==null?'':_.escape(__t))+
'\n                        ';
 }); 
__p+='\n                    )\n                ';
 } 
__p+='\n            </small>\n        </h5>\n        ';
 if (model.get('description')) { 
__p+='\n            <p>'+
((__t=( model.get('description') ))==null?'':_.escape(__t))+
'</p>\n        ';
 } 
__p+='\n    </div>\n    <div class="btn-item-right btn-item-icon">\n        <i class="fa fa-check icon"></i>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/employer/templates/PayrollItemSelectionButton.html
// module id = 725
// module chunks = 1